const locales = {
  'en-GB': { slug: '', label: 'English', flag: '\u{1F1EC}\u{1F1E7}', hreflang: 'en-gb', isDefault: true },
  'de-DE': { slug: 'de-de', label: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}', hreflang: 'de' },
  'es-ES': { slug: 'es-es', label: 'Espanol', flag: '\u{1F1EA}\u{1F1F8}', hreflang: 'es' },
  'fr-FR': { slug: 'fr-fr', label: 'Francais', flag: '\u{1F1EB}\u{1F1F7}', hreflang: 'fr' },
  'ko-KR': { slug: 'ko-kr', label: 'Hangugeo', flag: '\u{1F1F0}\u{1F1F7}', hreflang: 'ko' },
  'pt-PT': { slug: 'pt-pt', label: 'Portugues', flag: '\u{1F1F5}\u{1F1F9}', hreflang: 'pt' },
};

const defaultLocale = 'en-GB';

// Build reverse map: slug/directory name -> locale code
const slugToLocale = {};
Object.entries(locales).forEach(([code, conf]) => {
  const key = conf.slug || 'en';
  slugToLocale[key] = code;
});

module.exports = { locales, defaultLocale, slugToLocale };
